import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheLegacyVision from "./sections/TheLegacyVision";
import TheSovereignPhilosophy from "./sections/TheSovereignPhilosophy";
import ArchitectingYourFuture from "./sections/ArchitectingYourFuture";
import SecureYourLegacy from "./sections/SecureYourLegacy";
import SuccessJurisdictions from "./sections/SuccessJurisdictions";
import OurApproach from "./sections/OurApproach";
import PrivateConsultation from "./sections/PrivateConsultation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheLegacyVision />
      <TheSovereignPhilosophy />
      <ArchitectingYourFuture />
      <SecureYourLegacy />
      <SuccessJurisdictions />
      <OurApproach />
      <PrivateConsultation />
      <Footer />
    </div>;
}